import { actionTypes } from './constants';
import { getSessionCurrency, getLocalCurrency } from '../utils/preferredCurrency';

const headerActionCreators = {
    setUpdateUserState: updateUserState => {
        return { type: actionTypes.SET_UPDATE_USER_STATE, updateUserState };
    },
    setUserTypeTrade: isUserTypeTrade => {
        return { type: actionTypes.SET_USER_TYPE_TRADE, isUserTypeTrade };
    },
    setUserTypeVip: isUserTypeVip => {
        return { type: actionTypes.SET_USER_TYPE_VIP, isUserTypeVip };
    },
    setIsEmailOnly: isEmailOnly => {
        return { type: actionTypes.SET_IS_EMAIL_ONLY, isEmailOnly };
    },
    setInitialTrackingFired: () => {
        return { type: actionTypes.INITIAL_TRACKING_FIRED };
    },
    resetTrackingFired: () => {
        return { type: actionTypes.RESET_TRACKING_FIRED };
    },
    toggleMobileMenu: isMobileMenuOpen => {
        return { type: actionTypes.TOGGLE_MOBILE_MENU, isMobileMenuOpen };
    },
    setAddCartItemMutationCompleted: () => {
        return { type: actionTypes.SET_ADD_CART_ITEM_MUTATION_COMPLETED };
    },
    setGoogleOneTapVisibility: isGoogleOneTapVisible => {
        return { type: actionTypes.SET_GOOGLE_ONE_TAP_VISIBILITY, isGoogleOneTapVisible };
    },
    setActiveLiveChatVisibility: isActiveLiveChatVisible => {
        return { type: actionTypes.SET_ACTIVE_LIVE_CHAT_VISIBILITY, isActiveLiveChatVisible };
    },
};

const currencyActionCreators = {
    populateCurrency: currency => {
        const sessionCurrency = getSessionCurrency();
        const localCurrency = getLocalCurrency();
        return {
            type: actionTypes.POPULATE_CURRENCY,
            payload: { sessionCurrency, localCurrency, currency },
        };
    },
};

const drawerActionCreators = {
    setDrawerState: isDrawerOpen => {
        return { type: actionTypes.SET_DRAWER_STATE, payload: { isDrawerOpen } };
    },
};

const actionCreators = {
    ...headerActionCreators,
    ...currencyActionCreators,
    ...drawerActionCreators,
};

export { actionCreators };
export default { actionCreators };
